<template>
  <div id="vanber">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>学校合作管理</el-breadcrumb-item>
      <el-breadcrumb-item>学校合作申请</el-breadcrumb-item>
    </el-breadcrumb>
    <hr />
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="申请日期">
        <el-date-picker
          v-model="formInline.apply_time"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions1"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData">
      <el-table-column label="意向合作学校" min-width="150">
        <template slot-scope="scope">
          <div class="sc">
            <img v-if="scope.row.img" :src="scope.row.img" />
            <div>
              <div class="name">{{scope.row.school_name}}</div>
              <div>{{scope.row.degree}}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="学校位置" :formatter="formatLocation" />
      <el-table-column prop="created_at" label="申请时间" min-width="120" />
      <el-table-column prop="pay_status" :formatter="format_pay_status" label="支付状态" />
      <el-table-column prop="audit_status" :formatter="status" label="审核状态" />
      <el-table-column label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            v-if="scope.row.pay_status === 'no_paid' || !scope.row.pay_status"
            @click="pay(scope.row.relation_id, scope.row.school_id)"
          >支付</el-button>
          <el-button
            v-else
            size="mini"
            type="primary"
            @click="pushRouter('schoolDetail', { schoolId: scope.row.school_id })"
          >查看学校信息</el-button>
          <!-- <el-button
              size="mini"
              type="primary"
              :disabled="scope.row.audit_status !== 'school_pass' || scope.row.pay_status === 'no_paid' || !scope.row.pay_status"
              @click="applyCooperation(scope.row)"
          >合作意向申请</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination
      background
      :total="total"
      :current-page="page"
      layout="total, prev, pager, next"
      @current-change="handleCurrentChange"
    ></el-pagination>-->
    <Pagination
      ref="pagination"
      :total="total"
      @size-change="getResumes"
      @current-change="getResumes"
    />
  </div>
</template>

<script>
import Pagination from "@/components/pagination"; // 分页组件
import formatter from "@/assets/js/mixins/formatter"; // 公用函数

export default {
  components: {
    Pagination
  },
  mixins: [formatter],
  data() {
    return {
      // schoolList: "",
      pickerOptions1: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      formInline: {
        apply_time: ""
      },
      // 分页
      total: 0, // 总数
      page: 1, // 当前页
      page_size: 10, // 每页条数
      tableData: []
    };
  },
  mounted() {
    // this.getSchool()
    // this.getList();
    this.getResumes();
  },
  methods: {
    formatContact(row) {
      if (row.contact) {
        return row.contact + "  " + row.contact_phone;
      } else {
        return "暂无学校联系人";
      }
    },
    // 查询
    onSubmit() {
      // this.getList();
      this.getResumes();
    },
    // async getList() {
    //   let params = {
    //     page: this.page,
    //     page_size: this.page_size,
    //     apply_start: this.formInline.apply_time[0],
    //     apply_end: this.formInline.apply_time[1]
    //   };
    //   let res = await this.$api.school.getCoopList(params);
    //   if (res.code === 0) {
    //     if (res.data.item !== []) {
    //       this.tableData = res.data.items;
    //       this.total = res.data.count;
    //       res.data.items.forEach((item, index) => {
    //         this.$api.school.getLogo(item.school_id).then(res => {
    //           if (res.code === 0 && res.data) {
    //             this.tableData[index].img = res.data;
    //           }
    //         });
    //       });
    //     }
    //   }
    // },
    async getResumes() {
      let params = {};
      if (this.formInline.apply_time) {
        params = {
          page: this.$refs.pagination.page,
          page_size: this.$refs.pagination.page_size,
          apply_start: this.formInline.apply_time[0],
          apply_end: this.formInline.apply_time[1]
        };
      } else {
        params = {
          page: this.$refs.pagination.page,
          page_size: this.$refs.pagination.page_size
        };
      }
      // params = this.delNullVal(params);

      let res = await this.$api.school.getCoopList(params);
      if (res.code === 0) {
        if (res.data.item !== []) {
          this.tableData = res.data.items;
          this.total = res.data.count;
          res.data.items.forEach((item, index) => {
            this.$api.school.getLogo(item.school_id).then(res => {
              if (res.code === 0 && res.data) {
                this.tableData[index].img = res.data;
              }
            });
          });
        }
      }
    },
    // 审核状态
    status(row) {
      switch (row.audit_status) {
        case "no_pass":
          return "未审核";
        case "school_pass":
          return "通过";
        default:
          return "未通过";
      }
    },
    format_pay_status(row) {
      switch (row.pay_status) {
        case "no_paid":
          return "未支付";
        case "paid":
          return "已支付";
        default:
          return "未支付";
      }
    },
    // 支付
    pay(relation_id, school_id) {
      this.$router.push({
        path: "/pay",
        query: {
          pay_subject: "school",
          relation_id: relation_id,
          school_id
        }
      });
    },
    // 添加意向
    applyCooperation(row) {
      this.$router.push({
        path: "/applyAdd",
        query: {
          school_id: row.school_id
        }
      });
    }
    // handleCurrentChange(val) {
    //   this.page = val;
    //   this.getList();
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/base.scss";
#vanber {
  position: relative;
  box-sizing: border-box;
  padding: 20px;
}

.sc {
  display: flex;
  align-items: center;
  img {
    width: 38px;
    height: 38px;
    margin-right: 8px;
  }
  .name {
    color: #0d0d0d;
    font-weight: 500;
  }
}
</style>